// DS 4.8 - Grid Variant
import React from 'react';
import c from 'classnames';
import s from './FacetListGrid.scss';
const FacetListGrid = ({ facets, columns, gap, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap
        }
    }, facets);
};
FacetListGrid.displayName = 'FacetListGrid';
export default FacetListGrid;

//# sourceMappingURL=FacetListGrid.js.map